(function(){
  if (window.__vnInit) return; window.__vnInit = true;
  document.documentElement.classList.add('vn-js');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function addCart(items, btn){
    if (btn) btn.disabled = true;
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ if (!r.ok) throw r; window.location.href = root + 'cart'; })
      .catch(function(){ if (btn) { btn.disabled = false; btn.textContent = 'Intenta de nuevo'; } });
  }
  function getList(){ try { return JSON.parse(localStorage.getItem('vs_lista') || '[]'); } catch (e) { return []; } }
  function setList(l){ try { localStorage.setItem('vs_lista', JSON.stringify(l)); } catch (e) {} }
  function paintList(){
    var l = getList();
    document.querySelectorAll('[data-vn-list]').forEach(function(b){
      var on = l.indexOf(b.getAttribute('data-vn-list')) > -1;
      b.classList.toggle('is-on', on);
      var t = b.querySelector('[data-t]'); if (t) t.textContent = on ? 'Guardado en tu lista' : 'Agregar a la lista';
    });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-vn-add]');
    if (t) { e.preventDefault(); addCart([{ id: +t.getAttribute('data-vn-add'), quantity: 1 }], t); return; }
    t = e.target.closest('[data-combo]');
    if (t) { e.preventDefault(); addCart(t.getAttribute('data-combo').split(',').map(function(id){ return { id: +id, quantity: 1 }; }), t); return; }
    t = e.target.closest('[data-vn-list]');
    if (t) { e.preventDefault(); var h = t.getAttribute('data-vn-list'), l = getList(), i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.push(h); setList(l); paintList(); return; }
    t = e.target.closest('[data-vn-share]');
    if (t) { e.preventDefault(); var u = location.href.split('?')[0];
      if (navigator.share) navigator.share({ title: document.title, url: u }).catch(function(){});
      else if (navigator.clipboard) navigator.clipboard.writeText(u).then(function(){ t.title = 'Enlace copiado'; }); return; }
    t = e.target.closest('[data-vn-pop]');
    if (t) { var p = t.parentNode.querySelector('.vnp__pop'); if (p) p.classList.toggle('is-open'); return; }
    t = e.target.closest('[data-vn-nav]');
    if (t) { var r = t.parentNode.querySelector('.vnp__rail'); r.scrollBy({ left: (+t.getAttribute('data-vn-nav')) * r.clientWidth * 0.9 }); return; }
    t = e.target.closest('[data-vn-write]');
    if (t) { e.preventDefault(); var j = document.querySelector('.jm-action-buttons__button, .jdgm-write-rev-link');
      if (j) { j.click(); } else { var w = document.querySelector('.jdgm-widget, .jdgm-rev-widg'); if (w) w.scrollIntoView(); } return; }
    t = e.target.closest('[data-vn-more] button');
    if (t) { t.closest('[data-vn-more]').classList.add('is-open'); return; }
    t = e.target.closest('[data-vn-qall]');
    if (t) { var bx = t.closest('[data-vn-filter]'); bx.querySelectorAll('[data-vn-extra]').forEach(function(x){ x.hidden = false; }); bx.querySelectorAll('[data-vn-qall]').forEach(function(x){ x.style.display = 'none'; }); return; }
    t = e.target.closest('[data-vn-help]');
    if (t) { var n = t.querySelector('b'); if (!t.dataset.done) { n.textContent = (+n.textContent + 1); t.dataset.done = 1; } }
  });
  function filter(box){
    var q = (box.querySelector('[data-vn-q]') || {}).value || '', st = (box.querySelector('[data-vn-star]') || {}).value || '', so = (box.querySelector('[data-vn-sort]') || {}).value || '';
    q = q.toLowerCase();
    if (q || st) box.querySelectorAll('[data-vn-extra]').forEach(function(x){ x.hidden = false; });
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-vn-item]'));
    items.forEach(function(it){
      var ok = (!q || it.textContent.toLowerCase().indexOf(q) > -1) && (!st || it.getAttribute('data-star') === st);
      it.style.display = ok ? '' : 'none';
    });
    if (so) { var par = items[0] && items[0].parentNode; if (!par) return;
      items.sort(function(a, b){ return so === 'new' ? (+b.dataset.date - +a.dataset.date) : so === 'high' ? (+b.dataset.star - +a.dataset.star) : so === 'low' ? (+a.dataset.star - +b.dataset.star) : 0; })
        .forEach(function(i){ par.appendChild(i); }); }
  }
  document.addEventListener('input', function(e){ var b = e.target.closest('[data-vn-filter]'); if (b) filter(b); });
  document.addEventListener('change', function(e){ var b = e.target.closest('[data-vn-filter]'); if (b) filter(b); });
  function recs(){
    document.querySelectorAll('[data-vn-recs]').forEach(function(el){
      fetch(el.getAttribute('data-vn-recs')).then(function(r){ return r.text(); }).then(function(h){
        var d = document.createElement('div'); d.innerHTML = h; var n = d.querySelector('[data-vn-recs-in]'), o = el.querySelector('[data-vn-recs-in]');
        if (n && o && n.querySelector('.vnp__rail')) { o.innerHTML = n.innerHTML; reveal(); paintList(); } else if (!el.querySelector('.vnp__rail')) el.style.display = 'none';
      }).catch(function(){ if (!el.querySelector('.vnp__rail')) el.style.display = 'none'; });
    });
  }
  function seen(){
    var el = document.querySelector('[data-vn-seen]'); var cur = el ? el.getAttribute('data-vn-seen') : '';
    var l = []; try { l = JSON.parse(localStorage.getItem('vs_vistos') || '[]'); } catch (e) {}
    if (el) { var row = el.querySelector('[data-vn-seen-row]'), show = l.filter(function(h){ return h !== cur; }).slice(0, 8);
      if (show.length) Promise.all(show.map(function(h){ return fetch(root + 'products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }); })).then(function(ps){
        ps.forEach(function(p){ if (!p || !p.featured_image) return; var a = document.createElement('a'); a.href = p.url; var i = document.createElement('img'); i.src = p.featured_image; i.alt = p.title; i.loading = 'lazy'; a.appendChild(i); row.appendChild(a); });
        if (row.children.length) el.hidden = false;
      });
    }
    if (cur) { l = l.filter(function(h){ return h !== cur; }); l.unshift(cur); try { localStorage.setItem('vs_vistos', JSON.stringify(l.slice(0, 12))); } catch (e) {} }
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .12 }) : null;
  function reveal(){
    document.querySelectorAll('.reveal:not([data-rv])').forEach(function(el){
      el.setAttribute('data-rv', 1);
      var i = Array.prototype.indexOf.call(el.parentNode.children, el) % 6; el.style.setProperty('--i', i);
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }
  window.vnReveal = reveal;
  function boot(){ paintList(); recs(); seen(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
